import { Injectable } from '@angular/core';
import { LoadArticleFileLoadError, LoadArticleNotFoundError, LoadArticleParseError, LoadArticleService } from '../load-article/load-article.service';
import { AlertHelper } from '@shared/alert/alert.helper';
import { ExportToolService } from '../../export-tool/export-tool.service';
import { ArticleVO } from '@article/model/vo/article.vo';
import { AdmintoolProjectService } from '../../project/admintool-project.service';

@Injectable({
  providedIn: 'root'
})
export class ImportArticleService {

  constructor(
    private alertHelper: AlertHelper,
    private loadArticleService: LoadArticleService,
    private exportToolService: ExportToolService,
    private admintoolProjectService: AdmintoolProjectService,
  ) { }

  public async importArticleFromWxDatabase(articleIdOrNumber: string): Promise<boolean> {
    try {
      const loadedArticle = await this.loadArticleService.loadArticleFromWxDatabase(articleIdOrNumber);
      const success = await this.exportToolService.saveArticle(loadedArticle.article, loadedArticle.wxArticle);
      if (!success) {
        await this.admintoolProjectService.clearCurrentArticle();
      }
      return true;
    } catch (error) {
      await this.handleError(error);
      return false;
    }
  }

  public async replaceArticleFromWxDatabase(article: ArticleVO, articleIdOrNumber: string): Promise<boolean> {
    try {
      await this.loadArticleService.replaceArticleFromWxDatabase(article, articleIdOrNumber);
      return true;
    } catch (error) {
      await this.handleError(error);
      return false;
    }
  }

  public async importArticleFromFile(): Promise<boolean> {
    try {
      const article = await this.loadArticleService.loadArticleFromFile();
      const success = await this.exportToolService.saveArticle(article);
      if (!success) {
        await this.admintoolProjectService.clearCurrentArticle();
      }
      return true;
    } catch (error) {
      await this.handleError(error);
      return false;
    }
  }

  public async replaceArticleFromFile(article: ArticleVO): Promise<boolean> {
    try {
      await this.loadArticleService.replaceArticleFromFile(article);
      return true;
    } catch (error) {
      await this.handleError(error);
      return false;
    }
  }

  private async handleError(error: any): Promise<void> {
    if (error instanceof LoadArticleNotFoundError) {
      await this.alertHelper.showError('admintool.importArticle.alert.notFound.title',
        'admintool.importArticle.alert.notFound.message', {translationParams: [error.articleIdOrNumber]});
    }
    if (error instanceof LoadArticleParseError) {
      await this.alertHelper.showError('admintool.replace_model.parse_error.title', error.message);
    }
    if (error instanceof LoadArticleFileLoadError) {
      console.log(error);
    }
  }
}
